import { FormField, isStepValid } from 'utils/registration/formUtils';
import A from 'actions/fsdo/fsdoContactActions';

const 
init = {
    errorMsg: false,
    status: 'invalid',
};

export default (state=init, action) => {
    switch(action.type) {
        case A.SET_EXISTING_EMAIL: return ((s, a) => ({...s,
            existingEmail: a.payload
        }))(state, action)

        case A.FSDO_SET_REQUEST_ERROR_MSG: return ((state, code, field) => {
            switch(code) {
                case 409: return {...state, 
                    status: 'invalid',
                    errorCode: code,
                    help: 'This Email address already exists. Please try another.'
                };

                default: return {...state};
            }
        })(state, action.payload.code, action.payload.field)

        case A.FSDO_TOGGLE_ERROR_MSG: return {...state, errorMsg: !state.errorMsg };

        default: return {...state};
    }
}